import json from './sprite.js';

export default {
    handle: 'SP_SPS1-Basketball',
    label: 'es_SPS1-Basketball_225002182',
    json,
};
